import React from 'react'
import VerificationCodeForm from '../components/LoginsComponents/VerificationCodeForm';
import Left from '../components/LoginsComponents/Left';
import Right from '../components/LoginsComponents/Right';

const VarificationCode = () => {
    return (
        <div className="Login d-flex flex-column flex-lg-row">
            <Left />
            <Right children={<VerificationCodeForm />} text="Don't have an account" link="/signup" btnText="Sign Up" />
        </div>
    )
}

export default VarificationCode;